// import React, { useEffect, useState } from "react";
// import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
// import PropTypes from "prop-types";
// import { useForm } from "react-hook-form";
// import { ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import {
//   createLedger,
//   getCustomers,
// } from "../../../../helpers/urlConfig/apiFunctions";
// import {
//   errorToastify,
//   successToastify,
// } from "../../../../Components/Common/Toaster";
// import { getSessionData } from "../../../../helpers/sessionDetailsParser";
// import { getCurrentDate } from "../../../../helpers/dateParser";
// import Select from "react-select";
// import errorResponseHandler from "../../../../helpers/errorResponseHandler";

// function LedgersCreate({
//   modal_list,
//   setmodal_list,
//   tog_list,
//   fetchData,
//   customer_id = null,
// }) {
//   const { register, handleSubmit, reset, setValue } = useForm({
//     defaultValues: {
//       debit: 0,
//       credit: 0,
//     },
//   });

//   console.log("customer_id", customer_id);

//   const [customers, setCustomers] = useState([]);
//   const [creditChecked, setCreditChecked] = useState(false);
//   const [debitChecked, setDebitChecked] = useState(false);

//   const onSubmit = async (data) => {

//     try {
//       console.log("data", data);
//       data.created_by = getSessionData("user_id");
//       data.created_at = getCurrentDate();
//       const response = await createLedger(data);
//       console.log("ledger response", response);

//       if (response.statusCode === 200) {
//         if (response.data.message) {
//           errorToastify(response.data.message);
//           fetchData();
//           setmodal_list(false);
//           reset();
//         } else {
//           successToastify("Ledgers Created Successfully!");
//           fetchData();
//           setmodal_list(false);
//           reset();
//         }
//       } else {
//         errorResponseHandler(response);
//       }
//     } catch (error) {
//       // Handle error
//       console.error("Error adding ledgers:", error);
//     }
//   };

//   const getCustomer = async () => {
//     try {
//       const response = await getCustomers();
//       if (response.statusCode === 200) {
//         setCustomers(response.data);
//       } else {
//         errorResponseHandler(response);
//       }
//     } catch (error) {
//       console.error("Error getting customers:", error);
//     }
//   };

//   useEffect(() => {
//     getCustomer();
//   }, []);

//   const handleCreditChange = () => {
//     setCreditChecked(!creditChecked);
//     setDebitChecked(false);
//   };

//   const handleDebitChange = () => {
//     setCreditChecked(false);
//     setDebitChecked(!debitChecked);
//   };

//   return (
//     <>
//       <ToastContainer />
//       <Modal
//         isOpen={modal_list}
//         toggle={() => {
//           tog_list();
//         }}
//         centered
//       >
//         <ModalHeader
//           className="bg-light p-3"
//           toggle={() => {
//             tog_list();
//           }}
//         >
//           Update
//         </ModalHeader>
//         <form className="tablelist-form" onSubmit={handleSubmit(onSubmit)}>
//           <ModalBody>
//             {/* <div className="mb-3">
//               <label htmlFor="customer_id" className="form-label">
//                 Customer Name
//               </label>
//               <select
//                 id="customer_id"
//                 className="form-control"
//                 {...register("customer_id", {
//                   required: "Customer Name is required",
//                 })}
//                 defaultValue={customer_id || ""}
//               >
//                 {customers.map((customer) => (
//                   <option
//                     key={customer.customer_id}
//                     value={customer.customer_id}
//                   >
//                     {customer.customer_name}
//                   </option>
//                 ))}
//               </select>
//             </div> */}
//             <div className="mb-3">
//               <label htmlFor="customer_id" className="form-label">
//                 Customer Name
//               </label>
//               <Select
//                 id="customer_id"
//                 options={customers.map((customer) => ({
//                   value: customer.customer_id,
//                   label: customer.customer_name,
//                 }))}
//                 defaultValue={
//                   customer_id
//                     ? {
//                         value: customer_id,
//                         label:
//                           customers.find((c) => c.customer_id === customer_id)
//                             ?.customer_name || "Select Customer",
//                       }
//                     : null
//                 }
//                 onChange={(selectedOption) => {
//                   setValue(
//                     "customer_id",
//                     selectedOption ? selectedOption.value : ""
//                   );
//                 }}
//                 placeholder="Select Customer..."
//                 isClearable
//                 isSearchable
//                 className="basic-single"
//                 classNamePrefix="select"
//               />
//               <input
//                 type="hidden"
//                 {...register("customer_id", {
//                   required: "Customer Name is required",
//                 })}
//               />
//             </div>
//             <div className="mb-3">
//               <label htmlFor="description" className="form-label">
//                 Description
//               </label>
//               <input
//                 type="text"
//                 id="description"
//                 className="form-control"
//                 placeholder="Enter Description"
//                 {...register("description", {
//                   required: "Description is required",
//                 })}
//               />
//             </div>
//             <input
//               type="radio"
//               id="debit"
//               name="type"
//               value="debit"
//               checked={debitChecked}
//               onChange={handleDebitChange}
//             />
//             <label htmlFor="debit">Debit</label>
//             <input
//               type="radio"
//               id="credit"
//               name="type"
//               value="credit"
//               checked={creditChecked}
//               onChange={handleCreditChange}
//             />
//             <label htmlFor="credit">Credit</label>
//             {debitChecked && (
//               <div className="mb-3">
//                 <label htmlFor="debit" className="form-label">
//                   Debit
//                 </label>
//                 <input
//                   type="text"
//                   id="debit"
//                   className="form-control"
//                   placeholder="Enter Debit"
//                   {...register("debit", {
//                     required: "Debit is required",
//                   })}
//                 />
//               </div>
//             )}{" "}
//             {creditChecked && (
//               <div className="mb-4">
//                 <label htmlFor="credit" className="form-label">
//                   Credit
//                 </label>
//                 <input
//                   type="text"
//                   id="credit"
//                   className="form-control"
//                   placeholder="Enter Credit"
//                   {...register("credit", {
//                     required: "Credit is required",
//                   })}
//                 />
//               </div>
//             )}
//           </ModalBody>
//           <ModalFooter>
//             <div className="hstack gap-2 justify-content-end">
//               <button
//                 type="button"
//                 className="btn btn-light"
//                 onClick={() => setmodal_list(false)}
//               >
//                 Close
//               </button>
//               <button type="submit" className="btn btn-success" id="add-btn">
//                 Update
//               </button>
//             </div>
//           </ModalFooter>
//         </form>
//       </Modal>
//     </>
//   );
// }

// // Add prop types for validation
// LedgersCreate.propTypes = {
//   modal_list: PropTypes.bool.isRequired, // Indicates whether the modal is open
//   setmodal_list: PropTypes.func.isRequired, // Function to toggle modal visibility
//   tog_list: PropTypes.func.isRequired, // Function to toggle the modal
//   fetchData: PropTypes.func.isRequired, // Function to fetch the updated product data
// };

// export default LedgersCreate;

import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import PropTypes from "prop-types";
import { useForm } from "react-hook-form";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  createLedger,
  getCustomers,
} from "../../../../helpers/urlConfig/apiFunctions";
import {
  errorToastify,
  successToastify,
} from "../../../../Components/Common/Toaster";
import { getSessionData } from "../../../../helpers/sessionDetailsParser";
import { getCurrentDate } from "../../../../helpers/dateParser";
import Select from "react-select";
import errorResponseHandler from "../../../../helpers/errorResponseHandler";

function LedgersCreate({
  modal_list,
  setmodal_list,
  tog_list,
  fetchData,
  customer_id,
}) {
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      customer_id: customer_id || "",
      description: "",
      type: "debit", // Default to debit
      debit: "0",
      credit: "0",
    },
  });

  const [customers, setCustomers] = useState([]);
  const type = watch("type"); // Watch the type field for conditional rendering

  // Fetch customers on mount
  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const response = await getCustomers();
        if (response.statusCode === 200) {
          setCustomers(response.data);
        } else {
          errorResponseHandler(response);
        }
      } catch (error) {
        console.error("Error fetching customers:", error);
        errorToastify("Failed to load customers");
      }
    };
    fetchCustomers();
  }, []);

  // Set customer_id when modal opens
  useEffect(() => {
    if (modal_list && customer_id) {
      setValue("customer_id", customer_id);
    }
  }, [modal_list, customer_id, setValue]);

  // Form submission handler
  const onSubmit = async (data) => {
    try {
      // const payload = {
      //   customer_id: data.customer_id,
      //   description: data.description,
      //   type: data.type,
      //   amount: data.type === "debit" ? data.debit : data.credit,
      //   created_by: getSessionData("user_id"),
      //   created_at: getCurrentDate(),
      // };
      data.debit = parseFloat(data.debit);
      data.credit = parseFloat(data.credit);
      data.created_by = getSessionData("user_id");
      data.created_at = getCurrentDate();

      console.log("Submitting payload:", data); // Debug payload

      const response = await createLedger(data);
      console.log("API Response:", response);

      if (response.statusCode === 200) {
        if (response.data.message && response.data.message.includes("error")) {
          errorToastify(response.data.message);
        } else {
          successToastify("Ledger created successfully!");
          fetchData();
          setmodal_list(false);
          reset();
        }
      } else {
        errorResponseHandler(response);
      }
    } catch (error) {
      console.error("Error creating ledger:", error);
      errorToastify("Failed to create ledger");
    }
  };
  return (
    <>
      <ToastContainer />
      <Modal isOpen={modal_list} toggle={tog_list} centered>
        <ModalHeader className="bg-light p-3" toggle={tog_list}>
          Create Ledger
        </ModalHeader>
        <form onSubmit={handleSubmit(onSubmit)}>
          <ModalBody>
            <div className="mb-3">
              <label htmlFor="customer_id" className="form-label">
                Customer Name
              </label>
              <Select
                id="customer_id"
                options={customers.map((customer) => ({
                  value: customer.customer_id,
                  label: customer.customer_name,
                }))}
                value={customers
                  .map((c) => ({
                    value: c.customer_id,
                    label: c.customer_name,
                  }))
                  .find((option) => option.value === watch("customer_id"))}
                onChange={(selectedOption) =>
                  setValue("customer_id", selectedOption?.value || "")
                }
                placeholder="Select Customer..."
                isClearable
                isSearchable
              />
              <input
                type="hidden"
                {...register("customer_id", {
                  required: "Customer Name is required",
                })}
              />
              {errors.customer_id && (
                <p className="text-danger">{errors.customer_id.message}</p>
              )}
            </div>

            <div className="mb-3">
              <label htmlFor="description" className="form-label">
                Description
              </label>
              <input
                type="text"
                id="description"
                className="form-control"
                placeholder="Enter Description"
                {...register("description", {
                  required: "Description is required",
                })}
              />
              {errors.description && (
                <p className="text-danger">{errors.description.message}</p>
              )}
            </div>

            <div className="mb-3">
              <label className="form-label">Type</label>
              <div>
                <input
                  type="radio"
                  id="debit"
                  value="debit"
                  {...register("type")}
                />
                <label htmlFor="debit" className="ms-1">
                  Debit
                </label>
                <input
                  type="radio"
                  id="credit"
                  value="credit"
                  className="ms-3"
                  {...register("type")}
                />
                <label htmlFor="credit" className="ms-1">
                  Credit
                </label>
              </div>
            </div>

            {type === "debit" && (
              <div className="mb-3">
                <label htmlFor="debit" className="form-label">
                  Debit Amount
                </label>
                <input
                  type="number"
                  id="debit"
                  className="form-control"
                  placeholder="Enter Debit Amount"
                  {...register("debit", {
                    required: "Debit amount is required",
                    min: { value: 0, message: "Amount cannot be negative" },
                  })}
                />
                {errors.debit && (
                  <p className="text-danger">{errors.debit.message}</p>
                )}
              </div>
            )}

            {type === "credit" && (
              <div className="mb-3">
                <label htmlFor="credit" className="form-label">
                  Credit Amount
                </label>
                <input
                  type="number"
                  id="credit"
                  className="form-control"
                  placeholder="Enter Credit Amount"
                  {...register("credit", {
                    required: "Credit amount is required",
                    min: { value: 0, message: "Amount cannot be negative" },
                  })}
                />
                {errors.credit && (
                  <p className="text-danger">{errors.credit.message}</p>
                )}
              </div>
            )}
          </ModalBody>
          <ModalFooter>
            <div className="hstack gap-2 justify-content-end">
              <button
                type="button"
                className="btn btn-light"
                onClick={() => setmodal_list(false)}
              >
                Close
              </button>
              <button type="submit" className="btn btn-success" id="add-btn">
                Create Ledger
              </button>
            </div>
          </ModalFooter>
        </form>
      </Modal>
    </>
  );
}

LedgersCreate.propTypes = {
  modal_list: PropTypes.bool.isRequired,
  setmodal_list: PropTypes.func.isRequired,
  tog_list: PropTypes.func.isRequired,
  fetchData: PropTypes.func.isRequired,
  customer_id: PropTypes.string,
};

export default LedgersCreate;
